module.exports = __webpack_public_path__ + "img/battery-area.67f3e7d5.svg";